// Minnesotaänger Mini App — v1 assistant display names + avatar config.
// New code (not from telegram-tt). Explicit table keyed by assistant_id
// (the scope's character segment, e.g. "gilbert") — NOT a naive
// capitalize(): multi-word / acronym / non-Latin personas must be listed
// here explicitly. A future SwiftUI client reproduces this table 1:1
// (same keys, same display strings).
//
// Optional avatar config: a persona may set an emoticon that replaces the
// display-name initial; unset personas fall back to the first letters of
// the display name (getFirstLetters already uppercases).

export const DISPLAY_NAMES: Record<string, string> = {
  gilbert: 'Gilbert',
  ludwig: 'Ludwig',
};

export interface AvatarConfigEntry {
  // Avatar content override; rendered via the letters span (getFirstLetters
  // extracts a leading emoji). Omit to fall back to the display-name initial.
  emoticon?: string;
}

// Empty by default — add an entry when a persona gets a dedicated avatar mark.
export const AVATAR_CONFIG: Record<string, AvatarConfigEntry> = {};

export function getDisplayName(assistantId: string): string {
  return DISPLAY_NAMES[assistantId] ?? assistantId;
}

// Avatar content: configured emoticon, else the display-name initial.
export function getAvatarLabel(assistantId: string): string {
  return AVATAR_CONFIG[assistantId]?.emoticon ?? getDisplayName(assistantId);
}
